import { uploadService } from '@/api/upload.service';
import type {
  UploadControllerGetCarDocumentUploadUrlData,
  UploadControllerGetCarImageUploadUrlData,
  UploadControllerGetCleaningFeeUploadUrlData,
  UploadControllerGetContractSignatureUploadUrlData,
  UploadControllerGetDamageMediaUploadUrlData,
  UploadControllerGetTrainingVideoUploadUrlData,
  UploadControllerGetUserDocumentUploadUrlData,
  UploadControllerGetVehicleTypeImageUploadUrlData,
} from '@carvia/ros-client-types';

import { useMutation } from '@tanstack/vue-query';

const QUERY_KEY = 'upload';

export const useUploadDamageMedia = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: ({
      file,
      params,
    }: {
      file: string | Blob;
      params: UploadControllerGetDamageMediaUploadUrlData['query'];
    }) => uploadService.uploadDamageMedia(params, file),
    onMutate: () => ({ showSuccessToast: false }),
  });
};

export const useUploadCleaningFeePhoto = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: ({
      file,
      params,
    }: {
      file: string | Blob;
      params: UploadControllerGetCleaningFeeUploadUrlData['query'];
    }) => uploadService.uploadCleaningFee(params, file),
    onMutate: () => ({ showSuccessToast: false }),
  });
};

export const useUploadCarImage = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: ({
      file,
      params,
    }: {
      file: string | Blob;
      params: UploadControllerGetCarImageUploadUrlData['query'];
    }) => uploadService.uploadCarImage(params, file),
    onMutate: () => ({ showSuccessToast: false }),
  });
};

export const useUploadVehicleTypeImage = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: ({
      file,
      params,
    }: {
      file: string | Blob;
      params: UploadControllerGetVehicleTypeImageUploadUrlData['query'];
    }) => uploadService.uploadVehicleTypeImage(params, file),
    onMutate: () => ({ showSuccessToast: false }),
  });
};

export const useUploadCarDocument = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: ({
      file,
      params,
    }: {
      file: string | Blob;
      params: UploadControllerGetCarDocumentUploadUrlData['query'];
    }) => uploadService.uploadCarDocument(params, file),
    onMutate: () => ({ showSuccessToast: false }),
  });
};

export const useUploadContractSignature = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: ({
      file,
      params,
    }: {
      file: string | Blob;
      params: UploadControllerGetContractSignatureUploadUrlData['query'];
    }) => uploadService.uploadContractSignature(params, file),
    onMutate: () => ({ showSuccessToast: false }),
  });
};

export const useUploadVideo = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: ({
      file,
      params,
    }: {
      file: string | Blob;
      params: UploadControllerGetTrainingVideoUploadUrlData['query'];
    }) => uploadService.uploadVideo(params, file),
    onMutate: () => ({ showSuccessToast: false }),
  });
};

export const useUploadUserDocument = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: ({
      file,
      params,
    }: {
      file: string | Blob;
      params: UploadControllerGetUserDocumentUploadUrlData['query'];
    }) => uploadService.uploadUserDocument(params, file),
    onMutate: () => ({ showSuccessToast: false }),
  });
};

export const useUploadInfringement = () => {
  return useMutation({
    mutationKey: [QUERY_KEY],
    mutationFn: (file: string | Blob) => uploadService.uploadInfringement(file),
    onMutate: () => ({ showSuccessToast: false }),
  });
};
